import { render, staticRenderFns } from "./claim-input-case.vue?vue&type=template&id=66a57f50&scoped=true&"
import script from "./claim-input-case.vue?vue&type=script&lang=js&"
export * from "./claim-input-case.vue?vue&type=script&lang=js&"
import style0 from "./claim-input-case.vue?vue&type=style&index=0&id=66a57f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a57f50",
  null
  
)

export default component.exports